// extracted by mini-css-extract-plugin
export default {"wrapper":"UserProfilePage_wrapper__Q50Es","content":"UserProfilePage_content__ppdnd"};